<template>
  <div>
    <router-view v-bind:news.sync="news"></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
      news: {
        title: '',
        text: '',
        post_date: '',
        file_data: '',
        template: '就業スタッフの皆様へ\n\n新しいニュースを配信いたしました。\n以下のURLからログインしてご覧ください。\n\nhttps://staff.ubiquitous-p.com/sLogin\n\n＜本件お問い合わせ先＞\n株式会社ユビキタス\nTEL：03-3537-3200\n※本メールは送信専用のため、ご返信いただいても返答いたしかねます。\nご不明な点などございましたら、担当営業へお問い合わせください。'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/index.vue